export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`, `54-56`],
  [`Грудь`, `49`, `52`, `55`, `58`, `61`, `64`],
  [`Длина`, `70`, `72`, `74`, `76`, `78`, `80`]
];
